import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from 'react';

type PairingWordsContextValue = {
  /** Words from 2nd device (pairing-display). Null when not on that screen. */
  offerWords: string[] | null;
  setOfferWords: (words: string[] | null) => void;
};

const PairingWordsContext = createContext<PairingWordsContextValue | null>(null);

export function PairingWordsProvider({ children }: { children: ReactNode }): JSX.Element {
  const [offerWords, setOfferWords] = useState<string[] | null>(null);
  const value: PairingWordsContextValue = {
    offerWords,
    setOfferWords: useCallback((w: string[] | null) => setOfferWords(w), []),
  };
  return (
    <PairingWordsContext.Provider value={value}>
      {children}
    </PairingWordsContext.Provider>
  );
}

export function usePairingWordsContext(): PairingWordsContextValue | null {
  return useContext(PairingWordsContext);
}
